import { Paper, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/material";
import * as React from "react";
import { Helpers } from "../../../utils/helpers";

export class AnalyticsConstants extends React.Component<any, any> {

    constructor(props) {
        super(props);

        this.state = {
            tab: "campaigns",
        }

        document.title = Helpers.documentTitle("Analytics constants");
    }

    onTabChange(_e, value) {
        this.setState({
            tab: value,
        })
    }

    render() {
        return <Paper elevation={0}>
            <TabContext value={this.state.tab}>
                <TabList
                    onChange={(e, value) => this.onTabChange(e, value)}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label="Campaigns" value="campaigns"/>
                    <Tab label="Countries" value="countries"/>
                    <Tab label="Tiers" value="tiers"/>
                    <Tab label="Coefficients" value="coefficients"/>
                </TabList>

                <div style={{ marginTop: 15 }}>
                    <TabPanel value="campaigns">Item One</TabPanel>
                    <TabPanel value="countries">Item Two</TabPanel>
                    <TabPanel value="tiers">Item Three</TabPanel>
                    <TabPanel value="coefficients">Item Three</TabPanel>
                </div>
            </TabContext>
        </Paper>
    }
}
